import React from 'react'
import PropTypes from 'prop-types'
import SpeedBoostUsageSummary from './SpeedBoostUsageSummary'

const SpeedBoostStatus = props => {
    return (
        <div className='speed-boost-status'>
            <SpeedBoostUsageSummary serviceDetails={props.serviceDetails} isLoaded={props.isLoaded} />
        </div>
    )
}

SpeedBoostStatus.propTypes = {
    serviceDetails: PropTypes.object.isRequired,
    isLoaded: PropTypes.bool.isRequired
}

export default SpeedBoostStatus



// WEBPACK FOOTER //
// ./resources/js/modules/SpeedBoostStatus.js